import { useContext } from 'react';
import {
  ProfileContext,
  ProfileContextInterface,
} from '../contexts/profileContext';

export const useGlobalProfile = (): ProfileContextInterface =>
  useContext(ProfileContext);
